module.exports = __webpack_public_path__ + "static/media/ur-PK.ec92033b.md";